import * as types from './actiontypes';
import uuidv4 from 'uuid/v4';

export const setFormV2ToasterVisibility = (showToaster, toasterVariant, toasterDescription, feature, timeout) => {
	return {
		type: types.SET_TOASTER_VISIBILITY,
		payload: {
			showToaster: showToaster,
			toasterVariant: toasterVariant,
			toasterDescription: toasterDescription,
			feature: feature,
			timeout: timeout,
			toasterId: uuidv4()
		}
	};
};
